import React, { useEffect, useState } from "react";
import { fetchDailyShloka } from "../lib/api";
import Yantra from "./Yantra";

export default function ShlokaSection() {
    const [sh, setSh] = useState(null);

    useEffect(() => {
        fetchDailyShloka()
            .then(setSh)
            .catch(() => {});
    }, []);

    return (
        <section
            data-testid="shloka-section"
            className="relative overflow-hidden py-28 md:py-36 bg-tattva-bg"
        >
            <Yantra
                className="absolute -left-20 top-1/2 -translate-y-1/2 w-[520px] h-[520px] hidden md:block"
                opacity={0.18}
            />
            <Yantra
                className="absolute -right-24 top-1/2 -translate-y-1/2 w-[460px] h-[460px] hidden md:block"
                stroke="#4A5A3C"
                opacity={0.12}
            />
            <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
                <p className="text-xs uppercase tracking-[0.3em] text-tattva-muted mb-8">
                    Shloka of the Day
                </p>
                {sh ? (
                    <>
                        <p
                            data-testid="shloka-sanskrit"
                            className="font-display text-3xl md:text-4xl lg:text-5xl text-tattva-terracotta leading-[1.4] mb-8"
                        >
                            {sh.sanskrit}
                        </p>
                        <p className="font-serif italic text-xl md:text-2xl text-tattva-ink mb-5 leading-relaxed">
                            {sh.transliteration}
                        </p>
                        <div className="w-12 h-px bg-tattva-ornament mx-auto my-6" />
                        <p className="text-tattva-ink text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
                            {sh.translation}
                        </p>
                        {sh.source && (
                            <p className="mt-6 text-xs uppercase tracking-[0.25em] text-tattva-muted">
                                — {sh.source}
                            </p>
                        )}
                    </>
                ) : (
                    <div className="h-32 animate-pulse bg-tattva-surface/40" />
                )}
            </div>
        </section>
    );
}
